// Action Constants

export enum ActionConstant {
	GET_USERS = 'FILE://PROFILE_MANAGEMENT/GET_USERS',
	GET_STATUS = 'FILE://PROFILE_MANAGEMENT/GET_STATUS',
	CLEAR_USERS = 'FILE://PROFILE_MANAGEMENT/CLEAR_USERS',
	CLEAR_STATUS = 'FILE://PROFILE_MANAGEMENT/CLEAR_STATUS',
}

// State Types

// Action Types
export interface Lists {
	type: ActionConstant.GET_USERS;
	count: number;
	rows: [];
}

export interface GetListType {
	type: ActionConstant.GET_USERS;
	data: Lists;
}
export interface GetStatusType {
	type: ActionConstant.GET_STATUS;
	status: number;
}

export interface ClearListType {
	type: ActionConstant.CLEAR_USERS;
}
export interface ClearStatusType {
	type: ActionConstant.CLEAR_STATUS;
}

export type ActionType = GetListType | GetStatusType | ClearListType | ClearStatusType;

export interface InitialState {
	usersFetching: boolean;
	statusCode: number;
	users: [];
	count: number;
}
